import { useState } from "react";
import { useSnackbar } from 'notistack';
import { Paper, Grid } from "@mui/material";
import Header from "./Header";
import { EndDateFilter, StartDateFilter } from "./DateFilter";
import {  getContarctExpiryReportApi } from "../apiService";
import { globalGetService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import { trackActivity } from "../../../utils/mixpanel";

const ContractExpiryReport = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false)
  const [reportData, setReportData] = useState({});
  const [error, setError] = useState({});
  const onFieldChange = (key, value) => {
    setReportData((prev) => {
      const updatedData = { ...prev, [key]: value };
      if (key === "start_date" && !value) { updatedData.end_date = null; }
      return updatedData;
    });
  };
  const onFocusChange = (keyParam) => { setError(prev => ({ ...prev, [keyParam]: '' })) }
  const onExportReport = (extention) => {
    const query = { file_type: extention, ...(reportData?.start_date && { start_date: reportData.start_date }), ...(reportData?.end_date && { end_date: reportData.end_date }) }
    setLoading(true)
    globalGetService(getContarctExpiryReportApi(query))
      .then(response => {
        setLoading(false)
        if (checkApiStatus(response)) {
          setReportData({})
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
          trackActivity('Item Export', { page_title: `Contract Expiry Report`, success_msg: response?.data?.message, payload: query, response: response?.data })
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
          trackActivity('Item Export', { page_title: `Contract Expiry Report`, error_msg: response?.data?.message, payload: query, response: response?.data })
        }
      });
  };
  return (
    <Paper square>
      <div className='custom-rpt-card'>
        <div className='rpt-card-header'>
          <Grid container columnSpacing={1} className='rpt-header-grid'>
            <Grid size={{ md: 10, xs: 10 }}>
              <Header title="Contract Expiry Report" description="Overview of All Active Contracts Approaching Expiry. Includes Contract Type, Counterparty, Expiry Dates, Renewal Status and Associated Assets." />
            </Grid>
            <Grid size={{ md: 2, xs: 2 }} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start" }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1} >
          <Grid size={{ md: 6, xs: 12 }} >
            <StartDateFilter isRequired={false} reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} isFutureDisabled={true} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <EndDateFilter isRequired={false} reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} disabled={!reportData?.start_date} />
          </Grid>
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default ContractExpiryReport